import { Injectable, inject } from '@angular/core';

import { UrlsProvider } from 'src/app/providers/urls';
import { State } from 'src/app/models/state';

/**
 * A single funnel entry within `window.funnel_confs.funnels`, as read by the
 * debug pseudo-state builder. Typed loosely (the dev-only builder only touches
 * a few fields) but without `any`: the funnel-config payload is third-party
 * shaped and not modelled elsewhere, so the indexable members are `unknown`.
 */
export interface DebugFunnelConf {
  uniqueIdentifier?: string;
  defaultFunnels?: DebugDefaultFunnel[];
  [key: string]: unknown;
}

/** A default-funnel row inside a `DebugFunnelConf`. */
export interface DebugDefaultFunnel {
  url?: string;
  step?: number;
  upsell?: unknown;
  downsell?: unknown;
  variants?: Array<{ url?: string }>;
  [key: string]: unknown;
}

@Injectable({ providedIn: 'root' })
export class UpsellDebugService {
  private readonly urlsProvider = inject(UrlsProvider);

  getPseudoState(): State | undefined {
    try {
      // TOUC-1243 prep a pseudo-state object if a developer is here
      // TODO improve this so data payload below is updated to match new tcr funnel_confs file format (so the right title/price show when in debugMode)
      if (localStorage.getItem('debugMode') === 'true') {
        const FUNNEL_CONFS = (window as unknown as { funnel_confs?: { funnels: Record<string, DebugFunnelConf> } })['funnel_confs']
          ? (window as unknown as { funnel_confs: { funnels: Record<string, DebugFunnelConf> } })['funnel_confs'].funnels
          : null;
        var currentUrl = document.location.pathname.replace(/\//g, '');
        let mainFunnel: DebugFunnelConf | undefined = undefined;
        const uniqueIdentifier = this.urlsProvider.getParameterFromUrl({
          url: window.location.href,
          parameter: "uid",
        });
        if (uniqueIdentifier) {
          mainFunnel = Object.keys(FUNNEL_CONFS!)
            .map((key) => {
              return FUNNEL_CONFS![key];
            })
            .find((e) => e.uniqueIdentifier === uniqueIdentifier);
        } else {
          mainFunnel = Object.keys(FUNNEL_CONFS!)
            .map((key) => {
              return FUNNEL_CONFS![key];
            })
            .find(
              (e) =>
                e.defaultFunnels &&
                e.defaultFunnels.find(
                  (e1) =>
                    e1.url === currentUrl ||
                    (e1.variants && e1.variants.find((e2) => e2.url === currentUrl)),
                ),
            );
        }


        console.log('mainFunnel ' + currentUrl, mainFunnel);
        var currentDefaultFunnel = mainFunnel!.defaultFunnels!.find((e) =>
          e.variants!.find((el) => el.url === currentUrl),
        );
        if (!currentDefaultFunnel) currentDefaultFunnel = mainFunnel!.defaultFunnels![0];
        var upsell = [currentDefaultFunnel.upsell];
        const step = this.urlsProvider.getParameterFromUrl({
          url: window.location.href,
          parameter: "step",
        });
        if (mainFunnel!.defaultFunnels!.length > 1) {
          for (var x = 1; x < mainFunnel!.defaultFunnels!.length; x++) {
            //console.log('[GH] checking upsells ' + x, mainFunnel.defaultFunnels[x]);
            currentDefaultFunnel = mainFunnel!.defaultFunnels![x];
            if (currentDefaultFunnel.step && step && (parseInt(step)) === currentDefaultFunnel.step) {
              upsell = [];
              if (currentDefaultFunnel.upsell) upsell.push(currentDefaultFunnel.upsell);
              else if (currentDefaultFunnel.downsell) upsell.push(currentDefaultFunnel.downsell);
            }
          }
        }

        console.log('resulting upsell ' + currentUrl, upsell);
        // pseudo initial order below so you can view the upsell without placing an initial order
        var pp =
          '{"date":' +
          new Date().getTime() +
          ',"taxData":{"accountDetails":{"shipTo":{"line1":"address","city":"city","region":"CA","country":"US","postalCode":"90210"}},' +
          '"productDetails":[{"productDescription":"Developer productDescription","description":"Developer description","taxCode":null,"number":"01tf4000003VJk1AAG","quantity":1,"amount":123.45}],"shipping":0,"total":123.45,' +
          '"affParameters":{"utmSource":"","utmMedium":"","utmCampaign":"","utmCampaignId":"","utmContent":"","utmTerm":"","affId":"","offId":"","subId1":"","subId2":"","subId3":"","subId4":"","subId5":"","referralUrl":"","landingUrl":"","salesFunnel":"Funnel"},"isValid":true},' +
          '"pageName":"Upsell","orderDetails":{"order":{"subscriptionFrequencyMultiplier":null,"subscriptionFrequency":null,"subscriptionTax":null,"subscriptionShipping":null,"subscriptionSubtotal":null,"subscriptionId":null,' +
          '"orderItems":[{"productTaxCode":null,"productDescription":"Developer productDescription","productImage":"","isBumpOffer":false,"productVariantSize":null,"productVariantColor":null,"productVariantName":null,"productVariantPrice":null,"productVariantId":null,"productName":"Developer productName","productPrice":123.45,"productId":"01tf4000003VJk1AAG","totalPrice":123.45,"quantity":1,"orderId":"a0F0m000002aDr5EAE","order":"ORD-000140144","name":"Order-257118","id":"a0D0m000001YjoNEAS"}],' +
          '"orderTransactionFee":0,"tax":12.81,"brand":"Badlands Ranch","shippingZipPostal":"90210","additionalBillingAddressLine":null,"additionalShippingAddressLine":null,' +
          '"billingApartment":null,"billingAddress":"123 main","billingZip":"10002","billingState":"New York","billingCity":"new york","billingCountry":"United States","shippingApartment":null,"shippingAddress":"saddr changed","shippingState":"California","shippingCity":"city","shippingCountry":"United States","shipToName":"sfirst slast","orderShippingCost":0,"orderSource":"Funnel","parrentUpsellOrderId":null,"orderType":"Standard","latitude":null,"longitude":null,' +
          '"total":123.45,"status":null,"date":"Thu 05/12/2019 11:10","name":"ORD-000140144","id":"a0F0m000002aDr5EAE","paymentMethod":"Credit Card","customerEmail":"b@c.com","customerName":"sfirst slast","accountId":"0010m00000MqbDiAAJ",' +
          '"affParameters":{"affId":"","offId":"","subId1":"","subId2":"","subId3":"","subId4":"","subId5":""},' +
          '"subscribed":false,"authorized":false},"paymentMethod":"Standard",' +
          '"upsells":[' +
          JSON.stringify(upsell[0]) +
          '],' +
          '"paymentMethod":"Standard"}}';
        var pseudoStateConstruct: State = JSON.parse(pp);
        console.log('developer edition detected with empty state. ', pseudoStateConstruct);
        return pseudoStateConstruct;
      }
    } catch (e) {
      console.log('TOUC-962 error', e);
    }
    return undefined;
  }
}
